import { createTeamsChannelsOptions } from '../actions/privateActions';
import type { ChannelOption, TeamOption } from '../store/schema/CalendarChannelPickerInterfaces';
import { addParentOptions, recomputeIndexForOptionsAndUpdate } from 'owa-calendar-composite-picker';
import { fetchTeamProfilePicture, fetchTeamsAndChannels } from 'owa-teams-services';
import { orchestrator } from 'satcheljs';
import { getCalendarChannelPickerStore } from '../selectors/getCalendarChannelPickerStore';

orchestrator(createTeamsChannelsOptions, async actionMessage => {
    const { account, viewStateId } = actionMessage;

    const teamOptions: TeamOption[] = [];
    let teams;

    try {
        teams = await fetchTeamsAndChannels();
    } catch (error) {
        return;
    }

    for (let team of teams) {
        const channelOptions: ChannelOption[] = [];

        if (team.channels) {
            for (let channel of team.channels) {
                const channelOption: ChannelOption = {
                    account: account,
                    displayName: channel.displayName,
                    id: channel.id,
                    uid: channel.creator
                        ? channel.creator.substring(0, channel.creator.indexOf(';'))
                        : '',
                    rid: channel.lastMessage?.id ? parseInt(channel.lastMessage.id) : 0,
                    mid: channel.lastMessage?.parentMessageId
                        ? parseInt(channel.lastMessage.parentMessageId)
                        : 0,
                    channelType: channel.channelType,
                    private: false,
                    parentId: channel.parentTeamId,
                    parentTeamName: team.displayName,
                    parentTeamSmtpAddress: team.smtpAddress,
                    isShown: false,
                    isFavorite: channel.isFavorite,
                    index: 0,
                };
                channelOptions.push(channelOption);
            }
        }

        let profilePictureUrl;

        //Work Item 57252: Reduce the number of calls to fetch Teams data
        try {
            const teamProfilePicture = await fetchTeamProfilePicture(team);
            profilePictureUrl = URL.createObjectURL(teamProfilePicture);
        } catch (error) {
            profilePictureUrl = '';
        }

        const teamOption: TeamOption = {
            account: account,
            displayName: team.displayName,
            id: team.id,
            smtpAddress: team.smtpAddress,
            profilePictureUrl: profilePictureUrl,
            isExpanded: false,
            isFavorite: team.isFavorite,
            isShown: true,
            children: channelOptions,
            index: 0,
        };
        teamOptions.push(teamOption);
    }

    addParentOptions(getCalendarChannelPickerStore(viewStateId), teamOptions);
    recomputeIndexForOptionsAndUpdate(getCalendarChannelPickerStore(viewStateId));
});
